import React from "react";

const sizeStyles = {
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const sizeValueStyles = {
  sm: "text-[14px]",
  md: "text-[16px]",
  lg: "text-[18px]",
  xl: "text-[20px]",
};

const iconSizeStyles = {
  sm: "text-[18px]",
  md: "text-[20px]",
  lg: "text-[24px]",
  xl: "text-[28px]",
};

const InfoText = ({
  title,
  icon = "info",
  value,
  size = "md", //sm,md,lg,xl
  textWrap = false,
  oneLine = false,
  color = "black", // primary, warning, success, danger, info, black, white
}) => {
  const colorStyles = {
    primary: "text-primary",
    warning: "text-warning",
    success: "text-success",
    danger: "text-danger",
    info: "text-info",
    black: "text-black",
    white: "text-white",
  };

  // Handle size as either a string or an object
  const textSize = typeof size === "object" ? size.textSize || "md" : size;
  const valueSize = typeof size === "object" ? size.valueSize || "md" : size;
  const iconSize = typeof size === "object" ? size.iconSize || "md" : size;

  // Check if value is a React element
  const isReactComponent = React.isValidElement(value);

  return (
    <div
      className={`flex ${
        title ? "text-neutrals flex-col gap-2" : "flex-row items-center gap-2"
      } ${oneLine && "!flex-row items-center"}`}
    >
      {title ? (
        <div
          className={`leading-tight font-medium ${sizeStyles[textSize]}`}
        >
          {title}
        </div>
      ) : (
        <span
          className={`material-symbols-rounded font-extralight ${iconSizeStyles[iconSize]}`}
        >
          {icon}
        </span>
      )}
      <div
        className={` ${colorStyles[color]}   ${
          !textWrap ? "text-nowrap leading-none" : "leading-tight"
        }  ${isReactComponent ? "" : sizeValueStyles[valueSize]} font-medium`}
      >
        {value === undefined || value === null || value === "" ? "-" : value}
      </div>
    </div>
  );
};

export default InfoText;
